export const CheckboxesTrigger = {
  EXPAND: `Показать еще`,
  SHRINK: `Скрыть`
};

export const Slider = {
  FROM: `От`,
  TO: `До`
};

export const RESET = `Очистить фильтр`;
